import { Maybe } from '@oberoninternal/travelbase-ds/entities/Maybe';

const filterRecursive = <
    P extends string,
    T extends Maybe<{ children: Maybe<Array<Maybe<T>>> } & { [key in P]: boolean }>
>(
    items: T[],
    filterBy: P
): T[] =>
    items
        .filter(item => !item?.[filterBy])
        .map(item => {
            if (!item?.children) {
                return item;
            }

            return {
                ...item,
                children: filterRecursive(item.children, filterBy),
            };
        });

export default filterRecursive;
